/* bm-legal: right of withdrawal form. Ported from the live withdrawal-form section: same fields, endpoint, two-step flow and
   request body. Strings come from the page's own JSON block (one entry per locale, taken from the live dictionary).
   Changes from the live script: the honeypot input is named hp_note (not "company"), is never sent, and when it is filled the
   form shows the success state without posting. */
(function () {
  var app = document.getElementById('wdr-app');
  var store = document.getElementById('lg-wd-i18n');
  if (!app || !store) return;
  var t = JSON.parse(store.textContent);
  app.querySelectorAll('[data-k]').forEach(function (el) { el.textContent = t[el.getAttribute('data-k')] || ''; });
  var f1 = document.getElementById('wdr-step1'), f2 = document.getElementById('wdr-step2'), done = document.getElementById('wdr-done');
  var e1 = document.getElementById('wdr-err1'), e2 = document.getElementById('wdr-err2'), data = {}, trap = '';
  function valid() {
    var n = f1.name.value.trim(), o = f1.orderReference.value.trim(), m = f1.email.value.trim();
    return n && o && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(m) && f1.confirm.checked;
  }
  function toApp() { window.scrollTo({ top: app.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' }); }
  function showDone() { f1.hidden = true; f2.hidden = true; done.hidden = false; toApp(); done.focus({ preventScroll: true }); }
  f1.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (!valid()) { e1.textContent = t.errReq; e1.hidden = false; return; }
    e1.hidden = true;
    trap = f1.elements.hp_note.value.trim();
    data = { name: f1.name.value.trim(), orderReference: f1.orderReference.value.trim(), email: f1.email.value.trim(), reason: f1.reason.value.trim(), locale: app.getAttribute('data-iso') };
    document.getElementById('r-name').textContent = data.name;
    document.getElementById('r-order').textContent = data.orderReference;
    document.getElementById('r-email').textContent = data.email;
    f1.hidden = true; f2.hidden = false; toApp(); f2.focus({ preventScroll: true });
  });
  document.getElementById('wdr-back').addEventListener('click', function () { f2.hidden = true; f1.hidden = false; });
  f2.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (trap) { showDone(); return; }
    var btn = document.getElementById('wdr-confirm'), back = document.getElementById('wdr-back');
    btn.disabled = true; back.disabled = true; e2.hidden = true;
    // 35 s is above nginx's 30 s proxy timeout, so a server 504 arrives first; a stalled connection still ends in an error.
    var settled = false, ctl = window.AbortController ? new AbortController() : null;
    function fail() { if (settled) return; settled = true; e2.textContent = t.errNet; e2.hidden = false; btn.disabled = false; back.disabled = false; }
    var timer = setTimeout(function () { if (ctl) ctl.abort(); fail(); }, 35000);
    fetch(app.getAttribute('data-endpoint'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) { clearTimeout(timer); if (settled) return; if (j && j.ok) { settled = true; showDone(); } else fail(); })
      .catch(function () { clearTimeout(timer); fail(); });
  });
  f1.querySelector('button[type=submit]').disabled = false;
  var boot = document.getElementById('wdr-boot'); if (boot) boot.hidden = true;
})();
